// removed by extract-text-webpack-plugin
module.exports = {"disabledInput":"RoleFields-disabledInput"};